module.exports = __webpack_public_path__ + "static/media/WU_STEPS_sender_inactive.1cc3ef9d.svg";